var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLeftArrow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "left-arrow_1_",
    "data-name": "left-arrow (1)",
    xmlns: "http://www.w3.org/2000/svg",
    width: 150,
    height: 124.588,
    viewBox: "0 0 150 124.588",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3536",
    "data-name": "Group 3536"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1194",
    "data-name": "Path 1194",
    d: "M141.568,92.205l.234.051H41.429L72.983,60.634a8.287,8.287,0,0,0,0-11.65l-4.91-4.912a8.213,8.213,0,0,0-11.593-.006L2.391,98.149a8.269,8.269,0,0,0,0,11.633L56.48,163.871a8.22,8.22,0,0,0,11.593,0l4.91-4.912a8.125,8.125,0,0,0,2.393-5.8,7.881,7.881,0,0,0-2.393-5.687l-31.91-31.8H141.68A8.5,8.5,0,0,0,150,107.262v-6.948A8.337,8.337,0,0,0,141.568,92.205Z",
    transform: "translate(0 -41.674)",
    fill: "#674188"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftArrow);
export default __webpack_public_path__ + "static/media/left-arrow.8b90c102115324f9c338b0a000f1b063.svg";
export { ForwardRef as ReactComponent };